import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function Form() {
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const profileFilter = chooseProfileFilter();

    const { id } = useParams();

    const path = '/governanceroom/observatorygroups/';
    const endpointBackend = config.endpoints.backend
    const paths = {
        endpointSave: endpointBackend + 'governanceroom/observatorygroups/save',
        endpointGetById: endpointBackend + 'governanceroom/observatorygroups/getById',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Grupo de Observatório",
        labelTitleEdit: "Editar Grupo de Observatório",
        labelTitleView: 'Visualizar Grupo de Observatório'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'name',
                    type: 'text',
                    label: 'Dimensão',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'description',
                    type: 'text',
                    label: 'Descrição',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
